module.exports = __webpack_public_path__ + "img/9.f4898563.jpg";